module.exports = __webpack_public_path__ + "img/trouver-un-cours.c0574c2c.png";